import { colors } from "@obs/tokens/index.stylex.ts";
import * as stylex from "@stylexjs/stylex";

import { ButtonPrimitive, type ButtonPrimitiveProps } from "../primitives/ButtonPrimitive";

const styles = stylex.create({
	root: {
		backgroundColor: {
			default: colors.accentBgStrong,
			":hover:not(:disabled)": colors.accentBgStrongActive,
			":active:not(:disabled)": colors.accentBgStrongActive,
			":disabled": colors.disabledBgDefault,
		},
		color: {
			default: colors.accentTxtInverted,
			":disabled": colors.disabledTxtDefault,
		},
	},
});

export function Primary(props: ButtonPrimitiveProps) {
	return <ButtonPrimitive {...props} sx={[styles.root, props.sx]} />;
}
